<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'add'?'Add': viewType == 'edit'?'Edit':"View" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span></h2>
                        </div>
                        <span @click="$emit('close')" class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                        <v-radio-group
                        :showReadOnly="viewType == 'view'"
                        v-model="formData.status"
                        inline
                        >
                            <v-radio color="primary" label="Active" :value="'Active'"></v-radio>
                            <v-radio color="error" label="Inactive" :value="'Inactive'"></v-radio>
                        </v-radio-group>
                    </v-col>
                    
                    <v-col cols='12' class="py-0 px-1">
                        <v-label>First Name<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('First Name')" placeholder="First Name"
                        v-model="formData.first_name" :showReadOnly="viewType == 'view'"/>
                    </v-col>

                    <v-col cols='12' class="py-0 px-1">
                        <v-label>Last Name<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Last Name')" placeholder="Last Name" v-model="formData.last_name" 
                        :showReadOnly="viewType == 'view'"/>
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Email<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Email')" placeholder="Email" v-model="formData.email" 
                        :showReadOnly="viewType == 'view'"/>
                    </v-col>

                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Mobile</v-label>
                        <TextFieldComponent placeholder="Mobile" type="number"
                            v-model="formData.mobile" :showReadOnly="viewType == 'view'"/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-col cols="12" align="end">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn :showReadOnly="viewType == 'view'"  type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import clientDetailsService from "@/api/service/ClientDetails/ClientDetailsService";
import TextFieldComponent from "@/components/TextFieldComponent.vue";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
    },
    data: () => ({
        formData: {
            first_name:null,
            last_name:null,
            email:null,
            mobile:null,
            status:null,
        },
        chips: [],
        organisationData:[]
    }),
    props:['designation','editLocationData','index','viewType','users','WHindex'],
    created() {
        console.log(this.designation,'designation!!')
            console.log(this.editLocationData,"dddd");
        if(this.viewType == 'add'){
            this.formData = {
                first_name: null,
                last_name: null,
                email: null,
                status: null,
                mobile: null,
            }
        } else {
            this.formData = {
                id: this.editLocationData.id,
                first_name: this.editLocationData.first_name,
                last_name: this.editLocationData.last_name,
                email: this.editLocationData.email,
                status: this.editLocationData.status,
                mobile: this.editLocationData.mobile,
                created: this.editLocationData.created,
                created_by: this.editLocationData.created_by
            }
        }
    },
    
    methods: {
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
              return [
                (v) => !!v || "E-mail is required.",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
              ];
            }
            if (name && name.toLowerCase() === "warehouse") {
              return [
                (v) => {
                  if (this.users || this.viewType === 'edit') return true;
                  return !!v || "Warehouse is required.";
                },
                (v) => {
                  if (this.users || this.viewType === 'edit' || !v) return true;
                  const warehouses = this.organisationData?.warehouse_details || [];
                  const exists = warehouses.some(
                    (org) =>
                      org.warehouse_name &&
                      org.warehouse_name.trim().toLowerCase() === v.trim().toLowerCase()
                  );
                  return exists ? "Warehouse already exists." : true;
                },
              ];
            }
          return [(v) => !!v || `${name} is required.`];
        },
        async save() {
          const result = await this.$refs.form.validate();
          if (result.valid) {
            if (this.viewType == "edit") {
              this.$emit("update-warehouse", this.formData, this.WHindex, this.index, this.viewType);
            } else if (this.viewType == "add") {
              this.$emit("update-warehouse", this.formData, this.WHindex, this.viewType);
            } else {
              this.$emit("save", this.formData, this.designation);
            }
        
            this.formData = {};
            this.$emit("close");
          } else {
            console.log("Form not valid", result.errors);
          }
        },
    },

    async mounted(){
        if (!this.formData.status) {
            this.formData.status = "Active"
        }
        if(!this.users){
            this.organisationData = await clientDetailsService.findOne({
              id: this.$route.query.id,
              collectionName: 'organisation'
            });
        }
    }
};
</script>
<style scoped>
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
.ch {
    margin: auto;
    overflow-y: auto;
    min-height: 130px;
    max-height: 130px;
    overflow-x: hidden;
}
</style>
